import './enter-approver-parent-information-page.scss';
import { ChildTag } from '@components/child-tag/child-tag';
import { EnterApproverParentInformationForm } from '@components/enter-approver-parent-information/form/enter-approver-parent-information-form';
import { PageHeader } from '@components/page-header/page-header';
import { useSelectedChildEligibility } from '@hooks/context/use-account-application-context';
import { useNavigateHomeIfNoChildSelected } from '@hooks/navigation/use-navigation-effects';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';

export const EnterApproverParentInformationPage = () => {
    const { enterApproverParentInformation } = useTranslation();
    const { header, ingress } = enterApproverParentInformation;
    const selectedChildEligibility = useSelectedChildEligibility();

    useNavigateHomeIfNoChildSelected();

    if (!selectedChildEligibility) {
        return null;
    }

    const childName = selectedChildEligibility.child.name;

    return (
        <div className="enter-approver-parent-information-container">
            <div className="enter-approver-parent-information-container__header">
                <ChildTag name={childName} />
                <PageHeader header={header} ingress={format(ingress, childName)} />
            </div>
            <EnterApproverParentInformationForm />
        </div>
    );
};
